export enum FullStory {
    Exclude = 'fs-exclude',
    Mask = 'fs-mask',
    Unmask = 'fs-unmask',
}
